import React, { Fragment, FC } from "react";
import UserProfileTab from "./UserProfileTab";
import user from "../../../../assets/user-img.png";
import "../../../../styles/user.admin.scss";
const ViewProfile: FC = () => {
  return (
    <Fragment>
      <div className="user">
        <div className="user__edit">
          <div className="user__edit--heading">
            <h1>User Information</h1>
            <div className="user__edit--heading-icon">
              <div className="right">
                <svg
                  width="20"
                  height="22"
                  viewBox="0 0 20 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0.875C10.8301 0.874946 11.6288 1.19255 12.2322 1.76267C12.8356 2.33279 13.198 3.11219 13.245 3.941L13.25 4.125H18.5C18.69 4.12506 18.8729 4.19724 19.0118 4.32697C19.1506 4.4567 19.2351 4.6343 19.248 4.82388C19.261 5.01346 19.2015 5.20089 19.0816 5.3483C18.9617 5.49571 18.7902 5.5921 18.602 5.618L18.5 5.625H17.704L16.424 18.645C16.3599 19.2941 16.0671 19.8993 15.598 20.3525C15.1289 20.8056 14.5139 21.0773 13.863 21.119L13.687 21.125H6.313C5.66046 21.125 5.02919 20.8929 4.53201 20.4703C4.03482 20.0477 3.70412 19.462 3.599 18.818L3.576 18.644L2.295 5.625H1.5C1.31876 5.62499 1.14366 5.55936 1.00707 5.44023C0.870481 5.32111 0.781648 5.15655 0.757 4.977L0.75 4.875C0.750008 4.69376 0.815643 4.51866 0.934767 4.38207C1.05389 4.24548 1.21845 4.15665 1.398 4.132L1.5 4.125H6.75C6.75 3.26305 7.09241 2.4364 7.7019 1.8269C8.3114 1.21741 9.13805 0.875 10 0.875ZM16.197 5.625H3.802L5.069 18.497C5.09705 18.7842 5.22362 19.0529 5.42722 19.2574C5.63082 19.4619 5.89892 19.5897 6.186 19.619L6.313 19.625H13.687C14.287 19.625 14.796 19.2 14.912 18.623L14.932 18.497L16.196 5.625H16.197ZM11.75 8.375C11.9312 8.37501 12.1063 8.44064 12.2429 8.55977C12.3795 8.67889 12.4684 8.84345 12.493 9.023L12.5 9.125V16.125C12.4999 16.315 12.4278 16.4979 12.298 16.6368C12.1683 16.7756 11.9907 16.8601 11.8011 16.873C11.6115 16.886 11.4241 16.8265 11.2767 16.7066C11.1293 16.5867 11.0329 16.4152 11.007 16.227L11 16.125V9.125C11 8.92609 11.079 8.73532 11.2197 8.59467C11.3603 8.45402 11.5511 8.375 11.75 8.375ZM8.25 8.375C8.43124 8.37501 8.60634 8.44064 8.74293 8.55977C8.87952 8.67889 8.96835 8.84345 8.993 9.023L9 9.125V16.125C8.99994 16.315 8.92776 16.4979 8.79803 16.6368C8.6683 16.7756 8.4907 16.8601 8.30112 16.873C8.11154 16.886 7.92411 16.8265 7.7767 16.7066C7.62929 16.5867 7.5329 16.4152 7.507 16.227L7.5 16.125V9.125C7.5 8.92609 7.57902 8.73532 7.71967 8.59467C7.86032 8.45402 8.05109 8.375 8.25 8.375ZM10 2.375C9.56081 2.37502 9.13768 2.54017 8.81461 2.83768C8.49154 3.13519 8.29214 3.5433 8.256 3.981L8.25 4.125H11.75C11.75 3.66087 11.5656 3.21575 11.2374 2.88756C10.9092 2.55937 10.4641 2.375 10 2.375Z"
                    fill="#666666"
                  />
                </svg>
              </div>
              <div className="left">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.89167 19.1099C1.75293 19.1097 1.61576 19.0806 1.48888 19.0244C1.36199 18.9683 1.24818 18.8864 1.15467 18.7839C1.05947 18.6823 0.986823 18.5617 0.941498 18.43C0.896173 18.2984 0.879193 18.1586 0.891669 18.0199L1.13667 15.3259L12.4547 4.01191L15.9917 7.54791L4.67667 18.8609L1.98267 19.1059C1.95242 19.1087 1.92205 19.11 1.89167 19.1099ZM16.6977 6.84091L13.1617 3.30491L15.2827 1.18391C15.3755 1.09094 15.4858 1.01718 15.6072 0.966852C15.7286 0.916528 15.8588 0.890625 15.9902 0.890625C16.1216 0.890625 16.2517 0.916528 16.3731 0.966852C16.4945 1.01718 16.6048 1.09094 16.6977 1.18391L18.8187 3.30491C18.9116 3.39778 18.9854 3.50807 19.0357 3.62947C19.0861 3.75087 19.112 3.881 19.112 4.01241C19.112 4.14383 19.0861 4.27395 19.0357 4.39535C18.9854 4.51675 18.9116 4.62704 18.8187 4.71991L16.6987 6.83991L16.6977 6.84091Z"
                    fill="#666666"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div className="user__edit--flex">
            <div className="user__edit--flex--userinfo">
              <div className="user__edit--flex--userinfo-wrap">
                <div className="img-wrapper">
                  <img src={user} alt="user" />
                </div>
                <div className="user-details">
                  <h1>Micheal Owen</h1>
                  <p>Product Designer</p>
                  <div className="user-details-address">
                    <p>
                      <svg
                        width="19"
                        height="25"
                        viewBox="0 0 19 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.33152 24.5C7.64776 23.0638 6.08707 21.4893 4.66576 19.7929C2.53284 17.2454 1.17163e-06 13.4515 1.17163e-06 9.83619C-0.000923846 7.98983 0.545906 6.1847 1.57129 4.64924C2.59667 3.11378 4.0545 1.91701 5.7603 1.2104C7.4661 0.503795 9.34318 0.319102 11.154 0.679701C12.9648 1.0403 14.6279 1.92998 15.9329 3.23615C16.8017 4.10112 17.4904 5.12983 17.959 6.26272C18.4276 7.39562 18.6669 8.6102 18.663 9.83619C18.663 13.4515 16.1302 17.2454 13.9973 19.7929C12.576 21.4893 11.0153 23.0638 9.33152 24.5ZM9.33152 5.83697C8.27086 5.83697 7.25364 6.25832 6.50364 7.00832C5.75364 7.75832 5.33229 8.77553 5.33229 9.83619C5.33229 10.8969 5.75364 11.9141 6.50364 12.6641C7.25364 13.4141 8.27086 13.8354 9.33152 13.8354C10.3922 13.8354 11.4094 13.4141 12.1594 12.6641C12.9094 11.9141 13.3307 10.8969 13.3307 9.83619C13.3307 8.77553 12.9094 7.75832 12.1594 7.00832C11.4094 6.25832 10.3922 5.83697 9.33152 5.83697Z"
                          fill="#666666"
                        />
                      </svg>
                    </p>
                    <button className="message">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5 2.5C6.986 2.5 2.5 6.089 2.5 10.5C2.5 13.408 4.398 16.016 7.5 17.434V22.5L12.84 18.495C18.197 18.352 22.5 14.82 22.5 10.5C22.5 6.089 18.014 2.5 12.5 2.5ZM12.5 16.5H12.167L9.5 18.5V16.083L8.859 15.836C6.17 14.801 4.5 12.756 4.5 10.5C4.5 7.191 8.089 4.5 12.5 4.5C16.911 4.5 20.5 7.191 20.5 10.5C20.5 13.809 16.911 16.5 12.5 16.5Z"
                          fill="white"
                        />
                      </svg>
                      Send Message
                    </button>
                    <button className="mail">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M22.5 6.5C22.5 5.4 21.6 4.5 20.5 4.5H4.5C3.4 4.5 2.5 5.4 2.5 6.5V18.5C2.5 19.6 3.4 20.5 4.5 20.5H20.5C21.6 20.5 22.5 19.6 22.5 18.5V6.5ZM20.5 6.5L12.5 11.5L4.5 6.5H20.5ZM20.5 18.5H4.5V8.5L12.5 13.5L20.5 8.5V18.5Z"
                          fill="white"
                        />
                      </svg>
                      Send Mail
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="user__edit--tab">
              <UserProfileTab />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default ViewProfile;
